import { Avatar, Box, Button, Chip, Grid, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import ConfirmationBox from 'src/Component/ConfirmationBox'
import SimpleModal from 'src/Component/SimpleModal'
import { useGetParkByIdQuery } from 'src/api/manageParksApi'
import { AppDispatch } from 'src/store'
import { startPageLoader, stopPageLoader } from 'src/store/features/common/commonSlice'

type ViewParkDetailsModalProps = {
  id: number
  open: boolean
  onClose: () => void
}
const ViewParkDetailsModal = ({ id, open, onClose }: ViewParkDetailsModalProps) => {
  const dispatch = useDispatch<AppDispatch>()
  const { data, isFetching, refetch } = useGetParkByIdQuery(id)

  useEffect(() => {
    if (isFetching) {
      dispatch(startPageLoader())
    } else {
      dispatch(stopPageLoader())
    }
  }, [isFetching])

  return (
    <Box>
      <SimpleModal open={!!(open && id)} onClose={onClose}>
        {!!data && (
          <Box>
            {!!data?.picture && (
              <Box textAlign='center'>
                <img
                  src={data?.picture}
                  style={{
                    height: '250px',
                    objectFit: 'cover',
                  }}
                />
              </Box>
            )}

            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Park Name:</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'> {data?.name} </Typography>
              </Grid>
            </Grid>

            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Address:</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'>{data.address}</Typography>
              </Grid>
            </Grid>
            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>About:</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'>{data.about}</Typography>
              </Grid>
            </Grid>

            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Latitude:</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'>{data.latitude}</Typography>
              </Grid>
            </Grid>

            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Longitude:</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'> {data.longitude} </Typography>
              </Grid>
            </Grid>
            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Open:</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'> {data.opened_at} </Typography>
              </Grid>
            </Grid>
            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Close:</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'> {data.closed_at} </Typography>
              </Grid>
            </Grid>
          </Box>
        )}
      </SimpleModal>
    </Box>
  )
}

export default ViewParkDetailsModal
